import { createAction } from 'redux-actions';

import types from './types';

const setLoading = createAction(types.SET_LOADING);
const loadAddresses = createAction(types.LOAD_ADDRESSES);
const loadBillingAddresses = createAction(types.LOAD_BILLING_ADDRESSES);
const setAddresses = createAction(types.SET_ADDRESSES);
const setBillingAddresses = createAction(types.SET_BILLING_ADDRESSES);
const setInitial = createAction(types.SET_INITIAL);
const setAsDefault = createAction(types.SET_AS_DEFAULT);
const setWasShownMessage = createAction(types.SET_WAS_SHOWN_MESSAGE);
const removeMessage = createAction(types.REMOVE_MESSAGE);
const removeAddress = createAction(types.REMOVE_ADDRESS);
const removeWithConfirmation = createAction(types.REMOVE_WITH_CONFIRMATION);
const setAddressToRemove = createAction(types.SET_ADDRESS_TO_REMOVE);
const setSelectedAddressId = createAction(types.SET_SELECTED_ADDRESS_ID);
const setCurrentBillingAddressId = createAction(types.SET_CURRENT_BILLING_ADDRESS_ID);
const setCurrentDeliveryAddressId = createAction(types.SET_CURRENT_DELIVERY_ADDRESS_ID);
const setInvalidAddress = createAction(types.SET_INVALID_ADDRESS);
const setAddressBookType = createAction(types.SET_ADDRESS_BOOK_TYPE);
const setSelectedForPaymentAddresses = createAction(types.SET_SELECTED_FOR_PAYMENT_ADDRESSES);
const setAddressForPayment = createAction(types.SET_ADDRESS_FOR_PAYMENT);
const openAddressBook = createAction(types.OPEN_ADDRESS_BOOK);
const setNeighborhoodFieldInfo = createAction(types.SET_NEIGHBORHOOD_FIELD_INFO);

export default {
    setLoading,
    loadAddresses,
    setAddresses,
    setBillingAddresses,
    loadBillingAddresses,
    setInitial,
    setAsDefault,
    setWasShownMessage,
    removeMessage,
    removeAddress,
    removeWithConfirmation,
    setAddressToRemove,
    setSelectedAddressId,
    setCurrentBillingAddressId,
    setCurrentDeliveryAddressId,
    setInvalidAddress,
    setAddressBookType,
    setSelectedForPaymentAddresses,
    setAddressForPayment,
    openAddressBook,
    setNeighborhoodFieldInfo,
};
